import { IndexExpense } from "../index-expense";
import { Product } from "../product/product";
import { SubProduct } from "../subproduct/subproduct";
import { DataPeriod } from "../rtb/table/data-period";

export class updateInfoItem {
    id: string;
    index: number;
    currentLine: HTMLElement;
    month: number;
    parentId: string;
    year: number;
    dataId: IndexExpense;
    productCategoryId: string;
    dataPeriod: DataPeriod;
    settings: any;
    productId: string;
    product: Array<Product> | Array<SubProduct>;
    productTitle: string;
    action: string;
    productsLen: number;
    constructor(data) {
        this.id =  data.id;
        this.index =  data.index;
        this.currentLine =  data.currentLine;
        this.month =  data.month;
        this.parentId =  data.parentId;
        this.year =  data.year;
        this.dataId =  data.dataId;
        this.productCategoryId =  data.productCategoryId;
        this.dataPeriod =  data.dataPeriod;
        this.settings =  data.settings;
        this.productId =  data.productId;
        this.product =  data.product;
        this.productTitle =  data.productTitle;
        this.action =  data.action;
        this.productsLen =  data.productsLen;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/update-info-item.ts